export class ParsePointer {
    __type: string = 'Pointer';
    className: string;
    objectId: string;
    constructor(className: string, objectId: string) {
        this.className = className;
        this.objectId = objectId;
    }
}
